import { render, staticRenderFns } from "./SeriesSuggestion.vue?vue&type=template&id=6e08b632&"
import script from "./SeriesSuggestion.vue?vue&type=script&lang=js&"
export * from "./SeriesSuggestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports